import { render, staticRenderFns } from "./o-tabs.vue?vue&type=template&id=03363876&scoped=true&"
import script from "./o-tabs.vue?vue&type=script&lang=js&"
export * from "./o-tabs.vue?vue&type=script&lang=js&"
import style0 from "./o-tabs.vue?vue&type=style&index=0&id=03363876&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03363876",
  null
  
)

export default component.exports